import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { OrbitControls } from "../utils/CustomOrbitControls";
import { PLYLoader } from "three/examples/jsm/loaders/PLYLoader";
import { Html } from "@react-three/drei";


export default function ThreeMap(props) {
  const sceneRef = useRef(new THREE.Scene());
  const cameraRef = useRef(new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 200));
  const controlsRef = useRef(null);

  const [isPLYLoading, setIsPLYLoading] = useState(false);

  useEffect(() => {
    const renderer = new THREE.WebGLRenderer({antialias: false});
    renderer.setPixelRatio(1)
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);

    // cameraRef.current.position.set(90, 30, 20);
    cameraRef.current.position.set(0, 100, 0);
    controlsRef.current = new OrbitControls(cameraRef.current, renderer.domElement);

    // Lighting - add this
    const light = new THREE.PointLight(0xffffff, 1, 200);
    light.position.set(0, 30, 0);
    sceneRef.current.add(light);

    let animationFrameId;
    const animate = () => {
      animationFrameId = requestAnimationFrame(animate);
      renderer.render(sceneRef.current, cameraRef.current);
      console.log("renderer.info.render")
      console.log(renderer.info.render)
    };
    
    animate();

    return () => {
      // 1. requestAnimationFrameのキャンセル
      cancelAnimationFrame(animationFrameId);
  
      // 2. OrbitControlsのイベントリスナーの削除
      if (controlsRef.current) {
        controlsRef.current.dispose();
      }
  
      // 3. オブジェクトとマテリアルの解放
      if (sceneRef.current) {
        sceneRef.current.traverse(object => {
          if (!object.isMesh) return;
            
          console.log('dispose geometry!')
          object.geometry.dispose();
          
          if (object.material.isMaterial) {
            cleanMaterial(object.material);
          } else {
            for (const material of object.material) cleanMaterial(material);
          }
        });
      }
  
      document.body.removeChild(renderer.domElement);
      renderer.dispose();
    };
  }, []);

  useEffect(() => {
    if (controlsRef.current) {
      controlsRef.current.addEventListener("change", function () {
        console.log(`Camera Position: ${cameraRef.current.position.x}, ${cameraRef.current.position.y}, ${cameraRef.current.position.z}`);
      });
    }

    return () => {
      if (controlsRef.current) {
        console.log('dispose control!')
        controlsRef.current.dispose();
      }
    };
  }, []);

  const cleanMaterial = material => {
    console.log('dispose material!')
    material.dispose()
  
    // dispose textures
    for (const key of Object.keys(material)) {
      const value = material[key]
      if (value && typeof value === 'object' && 'minFilter' in value) {
        console.log('dispose texture!')
        value.dispose()
      }
    }
  }
  
  const isFirstFloodLoad = useRef(true);
  const isFirstLandLoad = useRef(true);
  const isFirstBuildingLoad = useRef(true);
  useEffect(() => {
    let isMounted = true;

    const loadPLYFiles = async () => {
      setIsPLYLoading(true)

      if (props.floodFile && isMounted) {
        if (isFirstFloodLoad.current || props.floodFile) {
          await addPLYFileToScene(props.floodFile, "floodFile");
          isFirstFloodLoad.current = false;
        }
      }
  
      if (props.landFile && isMounted) {
        if (isFirstLandLoad.current) {
          await addPLYFileToScene(props.landFile, "landFile");
          isFirstLandLoad.current = false;
        }
      }
  
      if (props.buildingFile && isMounted) {
        if (isFirstBuildingLoad.current) {
          await addPLYFileToScene(props.buildingFile, "buildingFile");
          isFirstBuildingLoad.current = false;
        }
      }

      setIsPLYLoading(false)
    };

    loadPLYFiles();
  
    return () => {
      isMounted = false;
    };
  }, [props.floodFile, props.landFile, props.buildingFile]);


  const removeExistingMesh = (name) => {
    const object = sceneRef.current.getObjectByName(name);
    if (object) {
      object.geometry.dispose();
      object.material.dispose();
      sceneRef.current.remove(object);
    }
  };

  const addPLYFileToScene = (fileContainer, name) => {
    
    let file;

    if (Array.isArray(fileContainer)) {
      file = fileContainer[0];
    } else if (fileContainer instanceof Blob) {
      file = fileContainer;
    } else {
      console.error("Unsupported file type");
      return;
    }
    if (file instanceof Blob) {
      let reader = new FileReader();
      let arraybuf;
      reader.readAsArrayBuffer(file);
  
      reader.onload = function () {
        arraybuf = reader.result;
        const loader = new PLYLoader();
        let geometry = loader.parse(arraybuf)
        geometry.computeVertexNormals();
        
        const material = new THREE.MeshPhongMaterial({
          color: 0xffffff,
          specular: 0x111111,
          shininess: 10,
          vertexColors: true
        });
        
        geometry.center();
        let mesh = new THREE.Mesh(geometry, material);
        mesh.name = name;
        removeExistingMesh(name);
        sceneRef.current.add(mesh);

        
        let boundingBox = new THREE.Box3();
        boundingBox.setFromObject(mesh);
        
        let meshSize = new THREE.Vector3(0,0,0);
        boundingBox.getSize(meshSize);
        
        const x = meshSize.x;
        const y = meshSize.y;
        const z = meshSize.z;
        const maxLength = Math.max(x, y, z);
        const power = maxLength / 100;
        const scaling = 1 / power;
        
        mesh.scale.set(scaling, scaling, scaling);
        sceneRef.current.add(mesh);
        
        if (controlsRef.current) {
          let maxDistance = meshSize.length();
          controlsRef.current.maxDistance = maxDistance * scaling;
        }
        
        if (sceneRef.current.getObjectByName("def")) {
          sceneRef.current.remove(sceneRef.current.getObjectByName("def"));
        }
      };
    } else {
      console.error("The file is not a Blob object");
    }
  };

  return (
    <Html>
      <div>
      </div>
    </Html>
  );
}